module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Attach":"Anhang","Upload failed":"Upload fehlgeschlagen"}}')
  delete Component.options._Ctor
}
